/* eslint-disable react/no-danger */
import { useEffect, useRef } from 'react';
import { transformToHtml } from '../../utils/CommonUtils';

export default function CityDT(props) {
  useEffect(() => {
    document.body.classList.add('bodyClass');
    document.body.id = 'cmsintlflt';
    document.body.setAttribute('data-domain', 'www_intl_flight_makemytrip_com');
  });
  const { blocksData, content } = props?.data || {};
  const containerRef = useRef(null);
  const middleBlockHtml = `${blocksData?.contentTop ? blocksData.contentTop : ""}${blocksData?.contentMiddle ? blocksData.contentMiddle : ""}${content ? content : ""}${blocksData?.contentBottom ? blocksData.contentBottom : ""}${blocksData?.bottomBlock ? blocksData.bottomBlock : ""}`;

  useEffect(() => {
    const buttons = containerRef.current?.querySelectorAll('.ViewFareBtn');
    if (buttons) {
      buttons?.forEach(button => {
        const url = button.getAttribute('data-url');
        if (url) {
          button.onclick = () => window.location.replace(url);
        }
      });
    }
  }, [middleBlockHtml]);

  // Before passing, make sure the string has data-url instead of onclick
  const sanitizedHtml = middleBlockHtml.replace(
    /onclick="[^"]*"/,
    ''
  );
  return (
    <>
      <div className="fli-intl-container prepend_top20 clearfix listingContainer">
        <div className="makeCenterCol clearfix noPadding">
          <div
            id="seoContentMiddle"
            className="seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12 paddL0 airline-left-container nopadding-mob paddR0 "
          >
            <div ref={containerRef}>
              {transformToHtml(sanitizedHtml)}
            </div>
          </div>
          <div
            id="seoRightBlock"
            className="seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 "
          >
            {transformToHtml(blocksData?.filterBlock)}
            {transformToHtml(blocksData?.rightBlock)}
            {transformToHtml(blocksData?.leftBlock)}
          </div>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: blocksData?.top_overlay }} />
      <div id="seo-bottom" className="seo">
        <input
          name="domain_id"
          id="domain_id"
          type="hidden"
          value="www_intl_flight_makemytrip_com"
        />
      </div>
    </>
  );
}
